module.exports = __webpack_public_path__ + "static/media/Aleo-BoldItalic.5a0474d8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Aleo-BoldItalic.eot
// module id = 2849
// module chunks = 71